import { formatEuro } from './evaluationFormatters';

export const VAT_FALLBACK_HINT_KEY = 'evaluation.vat.fallbackHint';

export function buildVatFallbackHint(count, amount) {
    const safeCount = Number(count) || 0;
    if (safeCount <= 0) {
        return '';
    }
    const posten = safeCount === 1 ? '1 Buchung' : `${safeCount} Buchungen`;
    return `Hinweis: Die Vorsteuer enthält ${formatEuro(amount)} aus ${posten} ohne Steuersatz – Beträge aus den Buchungen übernommen. Bitte Steuersätze prüfen.`;
}
